<template>
    <div v-if="ay_list != null">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Copy Lesson Plan</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <br />
            <v-row dense justify="center">

                <v-col cols="12" sm="4" md="4" style="text-align: right;">
                    <v-combobox rounded dense required return-object v-model="from_ay" :items="ay_list" item-text="ay"
                        label="From Academic Year" outlined />
                </v-col>
                <v-col cols="12" sm="1" md="1"></v-col>
                <v-col cols="12" sm="4" md="4" style="text-align: right;">
                    <v-combobox rounded dense required v-model="from_std" :items="standard_list" item-text="standard"
                        label=" Please Select Standard" outlined @change="getcourseoffering()" />
                </v-col>

            </v-row>
            <v-row dense justify="center">

                <v-col cols=" 12" sm="4" md="4" style="text-align: right;">
                    <v-combobox rounded dense required v-model="from_courseoffering" :items="courseoffering_list"
                        item-text="crs_name" return-object label="Please Select Course Offering" outlined multiple />
                </v-col>
                <v-col cols="12" sm="1" md="1" style="text-align: center;">
                    <v-btn text color="#0f2027" :loading="copy_btn_load">
                        <v-icon large color="#0f2027">mdi-arrow-right-bold-circle</v-icon>
                    </v-btn>
                </v-col>
                <v-col cols="12" sm="4" md="4" style="text-align: left;">
                    <v-combobox rounded dense required v-model="to_ay" return-object :items="ay_list" item-text="ay"
                        label="To Academic Year" outlined />
                </v-col>
            </v-row>

            <v-row justify="center
            ">
                <v-btn v-if="to_ay" class="button" :loading="loader" @click="copylessonplanDetails()">Copy Lesson
                    Plan</v-btn>

            </v-row>

        </v-card>
    </div>
</template>
<script>
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import axios from "axios";
export default {
    data: () => ({
        ay_list: null,
        courseoffering_list: null,
        to_ay: null,
        from_std: null,
        from_ay: null,
        from_courseoffering: null,
        from_slot_list: null,
        to_slot_list: null,
        search: "",
        copy_btn_load: false,
        standard_list: [],
        standard: null,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        loader: false,


    }),

    methods: {
        async copylessonplanDetails() {
            let formData = new FormData();
            if (this.from_courseoffering.length <= 0 || (this.from_courseoffering.length === 1 && this.from_courseoffering[0] === '')) {
                this.showSnackbar("red", "Please select Course...");
                return;
            }
            if (this.from_courseoffering.length > 1) {

                for (var i = 0; i < this.from_courseoffering.length; i++) {
                    if (this.from_courseoffering[i] != '') {
                        let stud = this.from_courseoffering[i].crs_id;

                        formData.append('coff_id[]', stud); // Using 'coff_id[]' to append multiple values
                    }
                }
            } else if (this.from_courseoffering.length === 1) {
                let stud = this.from_courseoffering[0].crs_id;

                formData.append("coff_id", stud);
            } else {

                formData.append("coff_id", '');
            }
            formData.append("ay", this.from_ay.id);
            formData.append("to_ay", this.to_ay.id);
            formData.append("standard", this.from_std.id);
            this.loader = true
            try {
                const res = await axios.post("/LessonPlanning/copylessonplanDetails", formData)
                if (res.data.flag == "YES") {
                    // this.showSnackbar("#4CAF50", "Copied Successfully...");
                    this.loader = false
                    this.onLoad()
                    this.showSnackbar("green", res.data.msg);
                } else if (res.data.flag == "NO") {
                    this.loader = false
                    this.showSnackbar("#b71c1c", res.data.msg);
                } else {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.loader = false
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }

                this.loader = false;
            }
            catch (err) {
                console.log("err", err)
                this.onerror(err);
                this.loader = false;
            }
            finally {
                console.log("bye...")
                this.loader = false;
            }
        },

        getcourseoffering() {
            const data = {
                ay: this.from_ay.id,
                standard: this.from_std.id,
            };
            axios
                .post("/LessonPlanning/getCourseListAll", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.courseoffering_list = res.data.course_offering_list;

                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.smsg);
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => { });
        },
        onLoad() {
            axios
                .post("/Examination/getInitialData")
                .then((res) => {
                    this.ay_list = res.data.ay_list;
                    this.standard_list = res.data.standard_list;
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => {
                    this.copy_offer_btn_load = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    mounted() {
        this.onLoad();
    },
};
</script>
<style scoped>
.mytable /deep/ thead th {
    background: #2980b9;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}
</style>
